import { ZipResultsCampaign } from 'entities/campaign';
import { Button } from 'shared/ui/Button';
import { getDataAutoTestAttributes } from 'shared/lib/data-auto-test';

import { useCampaignId, useDuplicateZipCount, useInvalidZipCount, useValidZipCount } from './CreateCampaignStoreHook';

type StepValidationProps = {
  onBack: () => void;
  onNext: () => void;
};

export function StepValidation(props: StepValidationProps) {
  const { onBack, onNext } = props;
  const validZipCount = useValidZipCount();
  const campaignId = useCampaignId();
  const duplicateZipCount = useDuplicateZipCount();
  const invalidZipCount = useInvalidZipCount();
  const hasMinimumOneValidZip = Boolean(validZipCount);
  const onlyInvalidZips = !validZipCount && !duplicateZipCount && Boolean(invalidZipCount);

  return (
    <div className="w-138">
      <div className="text-center text-xl font-medium tracking-normal">Target area validation results</div>
      <div className="mt-2 text-center text-sm font-normal">
        Please double-check the target area validation results. Duplicates and incorrect ZIP Codes (errors) will be not
        added to your campaign.
      </div>
      <ZipResultsCampaign
        className="mt-6"
        type="valid"
        titleCounter={validZipCount}
        campaignId={campaignId}
        {...getDataAutoTestAttributes(['expand-create-wizard-valid'])}
      />
      <ZipResultsCampaign
        className="mt-4"
        type="duplicate"
        titleCounter={duplicateZipCount}
        campaignId={campaignId}
        {...getDataAutoTestAttributes(['expand-create-wizard-duplicate'])}
      />
      <ZipResultsCampaign
        className="mt-4"
        type="invalid"
        titleCounter={invalidZipCount}
        campaignId={campaignId}
        onlyInvalid={onlyInvalidZips}
        {...getDataAutoTestAttributes(['expand-create-wizard-invalid'])}
      />
      <div className="mt-8 flex justify-between">
        <Button
          type="button"
          onClick={onBack}
          variant="outline-second"
          {...getDataAutoTestAttributes(['button-create-wizard-back'])}
        >
          Back
        </Button>
        <Button
          disabled={!hasMinimumOneValidZip}
          onClick={onNext}
          type="button"
          {...getDataAutoTestAttributes(['button-create-wizard-next'])}
        >
          Next
        </Button>
      </div>
    </div>
  );
}
